/* Uncle Mo's Tackle: Field Guide interactions (banner carousel, species tabs, scrolling rows) */
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function isKeyboardFocus(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return true; }
  }

  if (!customElements.get('fg-carousel')) {
    customElements.define('fg-carousel', class extends HTMLElement {
      connectedCallback() {
        if (!this._ready) this.setup();
        if (this._onVisibility) document.addEventListener('visibilitychange', this._onVisibility);
        this.sync();
      }
      disconnectedCallback() {
        clearInterval(this._timer);
        if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
      }
      setup() {
        var self = this;
        this._ready = true;
        this.slides = Array.prototype.slice.call(this.querySelectorAll('.fg-slide'));
        this.track = this.querySelector('.fg-carousel__track');
        this.counter = this.querySelector('[data-current]');
        this.toggleButton = this.querySelector('[data-toggle]');
        this.index = 0;
        for (var i = 0; i < this.slides.length; i++) {
          if (this.slides[i].classList.contains('is-active')) { this.index = i; break; }
        }
        this.delay = Math.max(2, parseFloat(this.dataset.speed) || 6) * 1000;
        this.paused = this.dataset.autoplay === 'false' || reduce.matches;
        this.hovering = false;
        if (this.slides.length < 2) return;
        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.sync(); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.sync(); });
        if (this.toggleButton) this.toggleButton.addEventListener('click', function () { self.paused = !self.paused; self.sync(); });
        if (this.track) {
          this.track.addEventListener('mouseenter', function () { self.hovering = true; self.sync(); });
          this.track.addEventListener('mouseleave', function () { self.hovering = false; self.sync(); });
        }
        this.addEventListener('focusin', function (e) {
          if (!self.contains(e.relatedTarget) && isKeyboardFocus(e.target) && !self.paused) { self.paused = true; self.sync(); }
        });
        this._onVisibility = function () { self.sync(); };
      }
      go(i) {
        var n = this.slides.length;
        var to = ((i % n) + n) % n;
        if (to === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[to].classList.add('is-active');
        this.index = to;
        if (this.counter) this.counter.textContent = (to < 9 ? '0' : '') + (to + 1);
      }
      sync() {
        clearInterval(this._timer);
        this._timer = null;
        if (!this.slides || this.slides.length < 2) return;
        var running = !this.paused && !this.hovering && !document.hidden;
        this.toggleAttribute('data-paused', this.paused);
        if (this.toggleButton) this.toggleButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
        if (this.track) this.track.setAttribute('aria-live', running ? 'off' : 'polite');
        var self = this;
        if (running) this._timer = setInterval(function () { self.go(self.index + 1); }, this.delay);
      }
    });
  }

  if (!customElements.get('fg-tabs')) {
    customElements.define('fg-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { self.select(i, false); });
          tab.addEventListener('keydown', function (e) {
            var n = self.tabs.length, j = -1;
            if (e.key === 'ArrowRight') j = (i + 1) % n;
            else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
            else if (e.key === 'Home') j = 0;
            else if (e.key === 'End') j = n - 1;
            if (j > -1) { e.preventDefault(); self.select(j, true); }
          });
        });
        this.addEventListener('shopify:block:select', function (e) {
          var i = self.tabs.indexOf(e.target);
          if (i > -1) self.select(i, false);
        });
      }
      select(i, focus) {
        this.tabs.forEach(function (tab, k) {
          var on = k === i;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) this.tabs[i].focus();
      }
    });
  }

  if (!customElements.get('fg-scroller')) {
    customElements.define('fg-scroller', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.strip = this.querySelector('.fg-strip');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.strip) return;
        function go(dir) {
          var button = dir < 0 ? self.prev : self.next;
          if (button && button.getAttribute('aria-disabled') === 'true') return;
          self.strip.scrollBy({ left: dir * self.strip.clientWidth * 0.9, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
        if (this.prev) this.prev.addEventListener('click', function () { go(-1); });
        if (this.next) this.next.addEventListener('click', function () { go(1); });
        this.strip.addEventListener('scroll', function () { self.update(); }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(function () { self.update(); }).observe(this.strip);
        else window.addEventListener('resize', function () { self.update(); });
        this.update();
      }
      update() {
        var s = this.strip;
        var max = s.scrollWidth - s.clientWidth;
        this.toggleAttribute('data-static', max <= 2);
        if (this.prev) this.prev.setAttribute('aria-disabled', s.scrollLeft <= 2 ? 'true' : 'false');
        if (this.next) this.next.setAttribute('aria-disabled', s.scrollLeft >= max - 2 ? 'true' : 'false');
      }
    });
  }
})();